// extracted by mini-css-extract-plugin
export var redoItem = "_q2-1";
export var redoTrigger = "_q2-0";